/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  APIIntercomMessengerToken,
  APITemporaryToken,
  List,
  URL,
  User,
  UserAPIToken,
  UserAPITokenExtended,
  UserTokenInfo,
} from "./data-contracts";

/**
 * @description Returns details about the user associated with the authentication provided in the request's authorization header.
 * @tags users, critical
 * @name GetAuthenticatedUser
 * @summary Get profile of authenticated user
 * @request GET:/user
 * @secure
 */

// @ts-ignore
export const getAuthenticatedUser: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/user",
  method: "get",
  streaming: false,
  tags: ["users", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name GetUserTokenInfo
 * @summary Get info about the token authenticating the request
 * @request GET:/user/token-info
 * @secure
 */

// @ts-ignore
export const getUserTokenInfo: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: UserTokenInfo;
  ResponseStatusCode: 200;
} = {
  route: "/user/token-info",
  method: "get",
  streaming: false,
  tags: ["users", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Generates a JWT for the authenticated user. This token is used by the frontend notifications client to access user endpoints.
 * @tags users
 * @name CreateUserNotificationsToken
 * @summary Create a JWT to access the in-app notifications service
 * @request POST:/user/notifications/token
 * @secure
 */

// @ts-ignore
export const createUserNotificationsToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: APITemporaryToken;
  ResponseStatusCode: 200;
} = {
  route: "/user/notifications/token",
  method: "post",
  streaming: false,
  tags: ["users"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name ListApiTokens
 * @summary List API tokens for the currently authenticated user
 * @request GET:/user/tokens
 * @secure
 */

// @ts-ignore
export const listAPITokens: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserAPIToken[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/user/tokens",
  method: "get",
  streaming: false,
  tags: ["users", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name CreateApiToken
 * @summary Create a new API token for the currently authenticated user
 * @request POST:/user/tokens
 * @secure
 */

// @ts-ignore
export const createAPIToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** The label for the API token */
    label: string;
  };
  RequestHeaders: {};
  ResponseBody: UserAPITokenExtended;
  ResponseStatusCode: 201;
} = {
  route: "/user/tokens",
  method: "post",
  streaming: false,
  tags: ["users", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name DeleteApiToken
 * @summary Delete an API token for user
 * @request DELETE:/user/tokens/{tokenId}
 * @secure
 */

// @ts-ignore
export const deleteAPIToken: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The id of the API token */
    tokenId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/user/tokens/{tokenId}",
  method: "delete",
  streaming: false,
  tags: ["users", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Provides publicly available information about someone with a GitBook account.
 * @tags users, critical
 * @name GetUserById
 * @summary Get a user by its ID
 * @request GET:/users/{userId}
 * @secure
 */

// @ts-ignore
export const getUserById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/users/{userId}",
  method: "get",
  streaming: false,
  tags: ["users", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Update a GitBook account's details.
 * @tags users, critical
 * @name UpdateUserById
 * @summary Update a user by its ID
 * @request PATCH:/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Full name for the user
     * @minLength 1
     * @maxLength 64
     */
    displayName?: string;
    photoURL?: URL;
  };
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["users", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags users, critical, internal
 * @name CreateIntercomMessengerToken
 * @summary Create an Intercom Messenger authentication token
 * @request POST:/internal/intercom/messenger-token
 * @secure
 */

// @ts-ignore
export const createIntercomMessengerToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: APIIntercomMessengerToken;
  ResponseStatusCode: 200;
} = {
  route: "/internal/intercom/messenger-token",
  method: "post",
  streaming: false,
  tags: ["users", "critical", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags users, critical, internal
 * @name SyncProfileWithAuth
 * @summary Sync the user's profile in the DB with their authentication account.
 * @request POST:/internal/profile/sync
 * @secure
 */

// @ts-ignore
export const syncProfileWithAuth: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/internal/profile/sync",
  method: "post",
  streaming: false,
  tags: ["users", "critical", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};
